import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/index.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowDown, faBan, faCheckCircle, faInfoCircle, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheckCircle, faPlus, faMinus, faInfoCircle, faArrowDown, faBan);
Vue.component("gp-icon", FontAwesomeIcon);

Vue.config.productionTip = false

Vue.filter("formatPrice", function (value) {
  return value
    .toFixed(2)
    .toString()
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

// Add to window object with custom name, so to avoid conflict with Ceres
window.gpVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#gp-konfigurator')
